import { PureComponent } from 'react'
import styled from '@emotion/styled'

import { env, getAppLayout } from '../../utils'
import { MainHeader } from '../mainHeader'
import notFound from '../../../images/notFound/hourglass.png'
import notFound2x from '../../../images/notFound/hourglass@2x.png'
import notFound3x from '../../../images/notFound/hourglass@3x.png'

const { hostname } = window.location
const { blockWebsiteRedirect } = getAppLayout(hostname)

const Content = styled.div(() => ({
  background: '#ffffff',
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  paddingTop: '2rem',
}))

const HourglassImage = styled.img(() => ({
  height: 'auto',
  maxHeight: '190px',
  maxWidth: '245px',
  width: 'auto',
}))

const Title = styled.h1(() => ({
  color: '#777794',
  fontSize: '1em',
  fontWeight: 700,
  textAlign: 'center',
  padding: '0 0.5em',
}))

export default class NotFound extends PureComponent {
  static redirect() {
    window.location = `https://${env('REACT_APP_WEBSITE_URL')}`
  }

  componentDidMount() {
    if (!blockWebsiteRedirect) {
      const timeout = Number.parseInt(env('REACT_APP_404_REDIRECT_TIMEOUT'), 10)
      setTimeout(NotFound.redirect, timeout)
    }
  }

  render() {
    return blockWebsiteRedirect ? (
      <div>
        <MainHeader />
        <Content>
          <Title>{env('REACT_APP_STRING_NOT_FOUND')}</Title>
          <HourglassImage
            alt="Oops, content not found"
            src={notFound}
            srcSet={`${notFound} 1x, ${notFound2x} 2x, ${notFound3x} 3x`}
          />
        </Content>
      </div>
    ) : null
  }
}
